import { render } from "./formset.vue?vue&type=template&id=6d1714cf&scoped=true"
import script from "./formset.vue?vue&type=script&lang=js"
export * from "./formset.vue?vue&type=script&lang=js"

import "./formset.vue?vue&type=style&index=0&id=6d1714cf&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1714cf"]])

export default __exports__